import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div
                className="min-h-screen flex items-center justify-center paper-texture text-[var(--vm-text-muted)]"
                data-testid="auth-loading"
            >
                Sprouting your session…
            </div>
        );
    }
    if (user === false) {
        // Root visits go to the public About/landing page; any deeper
        // protected route funnels through /login so we can bounce the
        // user back to where they wanted after they authenticate.
        if (location.pathname === "/") {
            return <Navigate to="/about" replace />;
        }
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}
